/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsAccessorialAnalytics
 */
export interface AllShipmentsAccessorialAnalytics {
  /**
   *
   * @type {string}
   * @memberof AllShipmentsAccessorialAnalytics
   */
  accessorial: string;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsAccessorialAnalytics
   */
  count: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsAccessorialAnalytics
   */
  bookedCount: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsAccessorialAnalytics
   */
  percentage: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsAccessorialAnalytics
   */
  bookedPercentage: number;
}

/**
 * Check if a given object implements the AllShipmentsAccessorialAnalytics interface.
 */
export function instanceOfAllShipmentsAccessorialAnalytics(
  value: object,
): value is AllShipmentsAccessorialAnalytics {
  if (!("accessorial" in value) || value["accessorial"] === undefined)
    return false;
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("bookedCount" in value) || value["bookedCount"] === undefined)
    return false;
  if (!("percentage" in value) || value["percentage"] === undefined)
    return false;
  if (!("bookedPercentage" in value) || value["bookedPercentage"] === undefined)
    return false;
  return true;
}

export function AllShipmentsAccessorialAnalyticsFromJSON(
  json: any,
): AllShipmentsAccessorialAnalytics {
  return AllShipmentsAccessorialAnalyticsFromJSONTyped(json, false);
}

export function AllShipmentsAccessorialAnalyticsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsAccessorialAnalytics {
  if (json == null) {
    return json;
  }
  return {
    accessorial: json["accessorial"],
    count: json["count"],
    bookedCount: json["bookedCount"],
    percentage: json["percentage"],
    bookedPercentage: json["bookedPercentage"],
  };
}

export function AllShipmentsAccessorialAnalyticsToJSON(
  json: any,
): AllShipmentsAccessorialAnalytics {
  return AllShipmentsAccessorialAnalyticsToJSONTyped(json, false);
}

export function AllShipmentsAccessorialAnalyticsToJSONTyped(
  value?: AllShipmentsAccessorialAnalytics | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    accessorial: value["accessorial"],
    count: value["count"],
    bookedCount: value["bookedCount"],
    percentage: value["percentage"],
    bookedPercentage: value["bookedPercentage"],
  };
}
